// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export class StorageSharedKeyCredential {
}
//# sourceMappingURL=StorageSharedKeyCredential.browser.js.map